/**
 * Process Block functionality
 *
 * @description This file includes the required functionality for the process ACF block
 *
 * @return void
 * @access public
 *
 */

import {addEventListenerIfElExists, getClosest} from './helpers';

export const process = () => {
	const processToggle = document.querySelectorAll( '.js-process-toggle' );

	/**
	 * Implement process functionality for FAQ Component
	 *
	 * @return void
	 * @since  1.0.0
	 * @access public
	 */
	processToggle.forEach( function ( element, index ) {

		element.addEventListener( 'click', function ( event ) {
			event.preventDefault();

			const parentItem     = getClosest( event.target, '.c-process__item' );
			const activeElements = Array.from( document.querySelectorAll( '.c-process__item--open' ) );
			const openClass      = 'c-process__item--open';

			if ( parentItem.classList.contains( openClass ) ) {
				activeElements.forEach( node => {
					node.classList.remove( openClass );
				} );
				parentItem.classList.remove( openClass );
			} else {
				activeElements.forEach( node => {
					node.classList.remove( openClass );
				} );
				parentItem.classList.add( openClass );
			}
		} );

	} );
}
